module.exports = __webpack_public_path__ + "static/media/neko-old-full.21168424.png";